import { mutationTypes } from '@/core/constants'
import rpCurrencyFilter from '@/views/filters/rp-currency-filter'

export default {
	[mutationTypes.ADESAO_PUBLICA.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ADESAO_PUBLICA.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ADESAO_PUBLICA.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.ADESAO_PUBLICA.SET_FORM_IS_VALID](state, isValido) {
		state.formIsValid = isValido
	},

	[mutationTypes.ADESAO_PUBLICA.SET_ID_SOLICITACAO_ADESAO](state, id) {
		state.idSolicitacaoAdesao = id
	},

	[mutationTypes.ADESAO_PUBLICA.SET_ESTADO_FORM](state, form) {
		state.estadoAnteriorForm = form
	},

	[mutationTypes.ADESAO_PUBLICA.SET_JUSTIFICATIVA](state, justificativa) {
		state.justificativa = justificativa
	},

	[mutationTypes.ADESAO_PUBLICA.SET_INFORMACOES_ITENS](state, objParam) {
		state.totalPaginas = objParam.totalPages
		state.totalItens = objParam.totalElements
		state.datasource = objParam.itens.map((item) => {
			item.quantidadeSolicitada = item.quantidadeSolicitada ? item.quantidadeSolicitada : null
			item._quantidadeSolicitada = item.quantidadeSolicitada
			return item
		})
	},

	[mutationTypes.ADESAO_PUBLICA.SET_INFORMACOES_ANEXOS](state, retorno) {
		state.anexos.datasource = retorno.itens
		state.anexos.totalPaginas = retorno.totalPages
		state.anexos.totalItens = retorno.totalElements
	},

	[mutationTypes.ADESAO_PUBLICA.RESETAR_ANEXOS_LISTAGEM](state, retorno) {
		state.anexos.datasource = []
		state.anexos.totalPaginas = 0
		state.anexos.totalItens = 0
	},
}
